import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const OrphanPostDocProofs = ({translation, docData, setCurrentStep, postSlug, isUpdate}) => {

  const [uploadedEetectricFile, setUploadedEetectricFile] = useState(false);
  const [uploadedFatherDeathCertificate, setUploadedFatherDeathCertificate] = useState(false);

  const [oldElectricBill, setOldElectricBill] = useState(null);
  const [oldFatherDeathCertificate, setOldFatherDeathCertificate] = useState(null);
  const [oldMotherDeathCertificate, setOldMotherDeathCertificate] = useState(null);
  const [oldBirthCertificate, setOldBirthCertificate] = useState(null);

  
  useEffect(()=>{
    if (docData){
      setOldFatherDeathCertificate(docData?.documents?.father_death_certificate)
      setOldElectricBill(docData?.documents?.electric_bill)
      setOldMotherDeathCertificate(docData?.documents?.mother_death_certificate)
      setOldBirthCertificate(docData?.documents?.birth_certificate)

      setUploadedFatherDeathCertificate(true)
      setUploadedEetectricFile(true)
    }
  }, [docData])
  
  return (
    <>
      <h2 className="mb-6 text-2xl dark:text-white">{translation.other.heading5}</h2>
      <form onSubmit={()=>{setCurrentStep("submit_view_post")}} className="pt-3 pb-6 space-y-4">
        {/* Electric Bill Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="electric_bill" className="block font-semibold mb-2 dark:text-white">
            {translation.other.elect_bill_name}
          </label>

          <FileUploader
            fileNameInDB={'electric_bill'}
            key="electric_file_uploader"
            allowedTypes={['jpeg','jpg', 'pdf', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedEetectricFile(true)
              setOldElectricBill(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.electric_bill_description}
            showPreview={oldElectricBill ? `${process.env.REACT_APP_CDN_URL}/${oldElectricBill}` : null} 
            
          />
        </div>


        
        {/* CNIC Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="birth_certificate" className="block font-semibold mb-2 dark:text-white">
            {translation.other.birth_certificate}
          </label>
          <FileUploader
            fileNameInDB={'birth_certificate'}
            key="birth_certificate_uploader"
            allowedTypes={['jpeg', 'pdf', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setOldBirthCertificate(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.birth_certificate_description}
            showPreview={oldBirthCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldBirthCertificate}` : null} 
          />
          
        </div>

        <div className="flex flex-col space-y-1">
          <label htmlFor="mother_death_certificate" className="block font-semibold mb-2 dark:text-white">
            {translation.other.mother_death_certificate}
          </label>

          <FileUploader
            fileNameInDB={'mother_death_certificate'}
            key="mother_death_certificate_file_uploader"
            allowedTypes={['jpeg', 'pdf', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setOldMotherDeathCertificate(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.mother_death_certificate_description}
            showPreview={oldMotherDeathCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldMotherDeathCertificate}` : null} 

          />
        </div>

        <div className="flex flex-col space-y-1">
          <label htmlFor="father_death_certificate" className="block font-semibold mb-2 dark:text-white">
            {translation.other.father_death_certificate}
          </label>

          <FileUploader
            fileNameInDB={'father_death_certificate'}
            key="father_death_certificate_file_uploader"
            allowedTypes={['jpeg', 'pdf','jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedFatherDeathCertificate(true)
              setOldFatherDeathCertificate(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.father_death_certificate_description}
            showPreview={oldFatherDeathCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldFatherDeathCertificate}` : null} 

          />
        </div>
        
        {/* Submit Button */}
        <div className="flex space-x-3">
            {isUpdate && 
              <button
                onClick={()=>{
                  setCurrentStep("attach_video_proofs");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }

            <button
              type="submit"
              className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
              disabled={ !uploadedFatherDeathCertificate || !uploadedEetectricFile}
            >
              {translation.next}
            </button>
        </div>
      </form>
    </>
  )
}

export default OrphanPostDocProofs;